import { render, staticRenderFns } from "./_bodefaultdomain.vue?vue&type=template&id=659a8d54&lang=pug"
import script from "./_bodefaultdomain.vue?vue&type=script&lang=js"
export * from "./_bodefaultdomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports